import { render, staticRenderFns } from "./InfoScreenDummy.vue?vue&type=template&id=89640d86&scoped=true&"
import script from "./InfoScreenDummy.vue?vue&type=script&lang=js&"
export * from "./InfoScreenDummy.vue?vue&type=script&lang=js&"
import style0 from "./InfoScreenDummy.vue?vue&type=style&index=0&id=89640d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89640d86",
  null
  
)

export default component.exports